import { ServiceAgreementRole } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import {
  BorrowerServiceAgreementInfo,
  LenderServiceAgreementInfo,
} from './information/service-agreement-info';

type ServiceAgreementInformation = {
  serviceAgreementPartyRole: ServiceAgreementRole;
  lenderServiceAgreementParty: { name: string };
  borrowerServiceAgreementParty: { name: string };
  workerPoolSize: number;
  flexPoolCount: number;
};

const serviceAgreementInformation = {
  LENDER: LenderServiceAgreementInfo,
  BORROWER: BorrowerServiceAgreementInfo,
};

export const useGetServiceAgreementDetailsTab = (data: ServiceAgreementInformation) => {
  const { t } = useTranslation('ogp-screen-specific');
  const Information = serviceAgreementInformation[data.serviceAgreementPartyRole];

  return [
    {
      id: 'service-agreement-information',
      tabLabel: t('collegial_lending_page.service-agreement.information'),
      element: <Information data={data} />,
    },
  ];
};
